export enum SymbolType {
  WHATSAPP = 'whatsapp',
  SMS = 'sms',
  VIBER = 'viber',
  INFORMATION = 'information',
}

export type SymbolSize = 20 | 24 | 32 | 40;

export type SymbolProps = {
  type: SymbolType;
  size?: SymbolSize;
};
